// 
// -----------------------------------------------------------------------------
(function ($cType) {
	if ($cType.length === 0) {return false;}

	$cType.find('.course-menu-toggle').on('click', function(){
		$cType.toggleClass('on');
		$cType.find('.course-menu').stop().slideToggle(300);
	});

})($( '.course-menu-wrap' ));